// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__G-F0w"};